@use 'src/globals/main';

pn-zipcode-search {
  display: block;
  color: main.$gray700;

  .search-results {
    display: flex;
    flex-direction: column;
    gap: 1em;
    padding: 0 0.75em;
    span {
      color: main.$gray700;
    }
    h3 {
      color: main.$gray900;
    }
  }

  .pn-error-text {
    color: main.$warning;
    padding: 0 0.75em;
  }

  > pn-search-field {
    width: 100%;
    margin-bottom: 1em;
  }
}
